<template>
  <div class="page-content">
    <div class="absolute-fullsize" v-if="loading" v-loading="loading"></div>
    <template v-else>
      <h1>{{ title }}</h1>

      <v-section top-indent>
        <v-toolbar>
          <!-- TODO: temporary hide action buttons -->
          <!-- <v-button theme="danger" :disabled="isButtonDisabled" @click="handleClick">{{ button }}</v-button> -->
        </v-toolbar>

        <hr />

        <div class="table-wrapper">
          <v-placements-table
            v-loading="loading"
            ref="placementsTable"
            :data="list"
            :default-sort="sort"
            selection-column
            :cpl="accountCPL"
            :classification-column="classificationColumn"
            :table-type="type"
            highlight-reason-property
            @sort-change="handleChangeSort"
            @selection-change="selection = $event"
          />

          <v-row justify="center" class="pagination-wrapper" v-if="totalPage && totalPage > 1">
            <v-pagination
              layout="prev, pager, next"
              :page-size="1"
              :current-page="currentPage"
              :total="totalPage"
              :disabled="loading"
              @current-change="handleChangeCurrentPage"
            />
          </v-row>
        </div>
      </v-section>

      <!-- dialogs -->
      <template v-if="canChangeBlacklistPlacements">
        <!-- delete from list -->
        <v-confirmation-dialog
          v-if="logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_ADD"
          ref="dialog"
          :title="$t('c.dialog.titleDeleteFromBlackList')"
          :message="$t('c.dialog.messageDeleteFromBlackList')"
          @confirm="changePlacementsToList(changeBlackListType, 'DELETE')"
        />
        <!-- add to list -->
        <v-confirmation-dialog
          v-else-if="logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_DELETE"
          ref="dialog"
          :title="$t('c.dialog.titleAddToBlackList')"
          :message="$t('c.dialog.messageAddToBlackList')"
          @confirm="changePlacementsToList(changeBlackListType, 'ADD')"
        />
      </template>
    </template>
  </div>
</template>

<script>
import VPlacementsTable from '@/components/Placements/VPlacementsTable.vue'
import VConfirmationDialog from '@/components/common/VConfirmationDialog.vue'
import VPagination from '@/components/common/VPagination.vue'
import VToolbar from '@/components/common/VToolbar.vue'
import VSection from '@/components/common/VSection.vue'
import VRow from '@/components/common/VRow.vue'
import * as types from '@/store/types'
import * as authorities from '@/utils/authorities'
import storeUtils from '@/mixins/storeUtils'
import { templates } from '@/utils/notification'
import * as logTypes from '@/constants/logTypes'

export default {
  name: 'ActionLogPlacements',

  components: {
    VPagination,
    VPlacementsTable,
    VToolbar,
    VRow,
    VSection,
    VConfirmationDialog
  },

  mixins: [storeUtils],

  data() {
    return {
      logTypes,
      type: types.ACTION_LOG_PLACEMENTS,
      changeBlackListType: types.CHANGE_BLACKLIST_PLACEMENTS,
      changeWhiteListType: types.CHANGE_WHITELIST_PLACEMENTS,
      selection: []
    }
  },

  computed: {
    accountCPL() {
      return this.$store.getters.accountCPL
    },
    loading() {
      return this.$store.state[this.type].loading
    },
    list() {
      return this.$store.state[this.type].list
    },
    sort() {
      return this.$store.state[this.type].params.sort
    },
    currentPage() {
      return this.$store.state[this.type].params.currentPage
    },
    totalPage() {
      return this.$store.state[this.type].params.totalPage
    },
    logType() {
      return this.$store.state[this.type].model.type
    },
    title() {
      if (this.logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_ADD) {
        return this.$t('v.actionLogPlacements.titleAddedToPersonalBlacklist')
      }
      if (this.logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_DELETE) {
        return this.$t(
          'v.actionLogPlacements.titleRemovedFromPersonalBlacklist'
        )
      }
      if (this.logType === logTypes.PLACEMENTS_WORST_AUTODISABLE) {
        return this.$t('v.actionLogPlacements.titleAutodisabled')
      }
      if (this.logType === logTypes.PLACEMENTS_WHITELIST_ADD) {
        return this.$t('v.actionLogPlacements.titleAddedToWhitelist')
      }
      if (this.logType === logTypes.PLACEMENTS_WHITELIST_SWITCH) {
        return this.$t(
          'v.actionLogPlacements.titleMovedFromBlacklistToWhitelist'
        )
      }
      // logType == logTypes.PLACEMENTS_WHITELIST_DELETE
      return this.$t('v.actionLogPlacements.titleRemovedFromWhitelist')
    },
    classificationColumn() {
      return this.logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_ADD
        || this.logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_DELETE
        || this.logType === logTypes.PLACEMENTS_WORST_AUTODISABLE
    },
    button() {
      if (this.logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_ADD) {
        return this.$t('v.actionLogPlacements.buttonDeleteFromBlacklist')
      }
      if (this.logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_DELETE) {
        return this.$t('v.actionLogPlacements.buttonAddToBlacklist')
      }
      if (this.logType === logTypes.PLACEMENTS_WORST_AUTODISABLE) {
        return this.$t('v.actionLogPlacements.buttonEnableAndAddToWhitelist')
      }
      if (
        [
          logTypes.PLACEMENTS_WHITELIST_ADD,
          logTypes.PLACEMENTS_WHITELIST_SWITCH
        ].includes(this.logType)
      ) {
        return this.$t('v.actionLogPlacements.buttonRemoveFromWhitelist')
      }

      // logType == logTypes.PLACEMENTS_WHITELIST_DELETE
      return this.$t('v.actionLogPlacements.buttonAddToWhitelist')
    },
    isButtonDisabled() {
      return !this.canChangeBlacklistPlacements
    },
    canChangeBlacklistPlacements() {
      return this.$store.getters.hasAuthorities(
        authorities.CHANGE_BLACKLIST_PLACEMENTS
      )
    }
  },

  created() {
    // reset to default values
    const model = {
      id: this.$route.params.id,
      type: null
    }
    const params = {
      sort: {
        prop: null,
        order: null
      },
      limit: 10,
      currentPage: 1,
      totalPage: null
    }
    const list = []

    this.setActionLogPlacementsModel(model)
    this.setActionLogPlacementsParams(params)
    this.setActionLogPlacementsList(list)
    this.fetchActionLogPlacements()
  },

  destroyed() {
    this.clearPlacementsLog(types.ACTION_LOG_PLACEMENTS)
  },

  methods: {
    handleChangeCurrentPage(value) {
      this.updateValue(this.type, { key: 'currentPage', value })
      this.fetchActionLogPlacements()
    },

    handleChangeSort({ prop, order }) {
      const { prop: oldProp, order: oldOrder } = this.$store.state[
        this.type
      ].params.sort

      if (prop !== oldProp || order !== oldOrder) {
        this.updateValue(this.type, { key: 'sort', value: { prop, order } })
        this.fetchActionLogPlacements()
      }
    },

    handleClick() {
      if (this.logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_ADD) {
        this.$refs.dialog.open()
      } else if (
        this.logType === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_DELETE
      ) {
        this.$refs.dialog.open()
      } else if (this.logType === logTypes.PLACEMENTS_WORST_AUTODISABLE) {
        this.changePlacementsToList(this.changeBlackListType, 'DELETE')
      } else if (
        [
          logTypes.PLACEMENTS_WHITELIST_ADD,
          logTypes.PLACEMENTS_WHITELIST_SWITCH
        ].includes(this.logType)
      ) {
        this.changePlacementsToList(this.changeWhiteListType, 'DELETE')
      } else {
        // logType == logTypes.PLACEMENTS_WHITELIST_DELETE
        this.changePlacementsToList(this.changeWhiteListType, 'ADD')
      }
    },
    openDialog() {
      this.$refs.dialog.open()
    },

    setActionLogPlacementsModel(model) {
      this.setModel(this.type, model)
    },

    setActionLogPlacementsList(list) {
      this.setList(this.type, list)
    },

    setActionLogPlacementsParams(params) {
      this.setParams(this.type, params)
    },

    updateValue(type, { key, value }) {
      const params = {
        [key]: value
      }

      this.updateParams(type, params)
    },

    fetchActionLogPlacements() {
      this.$store.dispatch(types.FETCH_ACTION_LOG_ITEM, { name: this.type })
    },

    notifyUserAboutActionResult(actionType, action, result) {
      const { new: changedPlacements, count, logId } = result
      let notificationTemplate

      if (!changedPlacements.length) return

      if (action === 'ADD') {
        notificationTemplate = actionType === this.changeWhiteListType
          ? templates.PLACEMENTS_ADDED_TO_WHITELIST
          : templates.PLACEMENTS_ADDED_TO_BLACKLIST
      }
      if (action === 'DELETE') {
        notificationTemplate = actionType === this.changeWhiteListType
          ? templates.PLACEMENTS_REMOVED_FROM_WHITELIST
          : templates.PLACEMENTS_REMOVED_FROM_BLACKLIST
      }

      this.$store.dispatch(types.PUSH_NOTIFICATION, {
        count,
        logId,
        list: changedPlacements,
        template: notificationTemplate
      })
    },

    changePlacementsToList(actionType, action) {
      const name = this.type
      const placements = this.selection.map(item => (action === 'ADD' ? item.domain : item.id))

      if (placements.length) {
        const { during } = placements[0]

        this.$store
          .dispatch(actionType, {
            name,
            placements,
            action,
            during
          })
          .then((result) => {
            this.notifyUserAboutActionResult(actionType, action, result)
            this.fetchActionLogPlacements()
          })
      }
    },

    clearPlacementsLog(name) {
      this.setList(name, [])
      this.setModel(name, {
        id: null,
        type: null
      })
      this.updateParams(name, {
        sort: {
          prop: null,
          order: null
        },
        currentPage: 1,
        totalPage: null
      })
    }
  }
}
</script>
